export default {
  currencyItems: [],
  currencyItem: undefined,
};
